module.exports = __webpack_public_path__ + "img/app_second.96945b91.png";